import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { localizationDefaults } from "src/utils";
import * as en from "./locales/en.json";
import * as fr from "./locales/fr.json";
import * as enTrade from "./locales/trade/en.json";
import * as frTrade from "./locales/trade/fr.json";

export const DEFAULT_LANGUAGE = "en";

const resources = {
    en: { translation: en, trade: enTrade },
    fr: { translation: fr, trade: frTrade },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        appendNamespaceToMissingKey: true,
        debug: process.env.NODE_ENV === "development",
        // https://github.com/i18next/i18next-browser-languageDetector#detector-options
        detection: {
            // `querystring` detects our test page language toggle
            // `htmlTag` & `path` detect the language toggle on DI websites
            order: ["querystring", "htmlTag", "path", "navigator"],
            lookupQuerystring: "language",
        },
        fallbackLng: DEFAULT_LANGUAGE,
        interpolation: {
            // react already safes from xss
            escapeValue: false,
        },
        keySeparator: false,
        resources,
    });

// note that i18n.language is a locale with country code, not just the language, unless we change the i18n config to ignore the country
export const getLocale = (): string => i18n.language || localizationDefaults.locale;

export default i18n;
